import { render, staticRenderFns } from "./orders-detail.vue?vue&type=template&id=77bfd219&scoped=true"
import script from "./orders-detail.vue?vue&type=script&lang=js"
export * from "./orders-detail.vue?vue&type=script&lang=js"
import style0 from "./orders-detail.vue?vue&type=style&index=0&id=77bfd219&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77bfd219",
  null
  
)

export default component.exports